module.exports = __webpack_public_path__ + "img/hello.f2ac16e0.png";